import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdOperationsGeneralConfiguration } from '@jira/navigation-apps__constants/src/SidebarIdOperationsGeneralConfiguration.tsx';
import {
	getNavigationResources,
	getNavigationSidebarProductsSettingResource,
} from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { opsSettingsLayout } from '@jira/platform__layouts-ops-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { eocGlobalMaintenanceRoute } from '@jira/router-routes__eoc-maintenance-routes/src/eocGlobalMaintenanceRoute.tsx';
import { LazySidebarContent } from '@jira/navigation-apps__sidebar-nav4-sidebars-settings-global-operations/src/ui/index.tsx';
import { resources as maintenanceResources } from '@atlassian/eoc-maintenance/resources';
import type { Route, RouteResources } from '@atlassian/react-resource-router';
import { LazyMaintenance, MaintenanceComponent } from './ui/MaintenanceComponent.tsx';

const getNavigationSpecifications = () => {
	return {
		sidebarId: SidebarIdOperationsGeneralConfiguration,
	};
};

export const eocGlobalMaintenanceRouteEntry: Route = createEntry(eocGlobalMaintenanceRoute, () => ({
	group: 'eoc',
	// eslint-disable-next-line no-restricted-syntax
	component: MaintenanceComponent,
	layout: opsSettingsLayout,

	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	resources: [
		...getNavigationResources(),
		...getNavigationSidebarProductsSettingResource(),
		...maintenanceResources(),
	] as RouteResources,

	navigation: {
		menuId: MenuIdSettings,
		...getNavigationSpecifications(),
	},

	forPaint: [LazySidebarContent, LazyAtlassianNavigation, LazyMaintenance],

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
